import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Target Search + Multi-select using TomSelect
//
// NOTE: This is distinct from the generic TomSelect controller as it uses a
// custom renderer function and AJAX loader.
//
// Used in Target Groups form to search for targets to add to the group.
// Will be used in the future in Route Settings + Datatable group modal
export default class extends Controller {
    static values = {
        preload: String,
    }

    connect() {
        const settings = {
            valueField: 'id',
            searchField: 'name',
            plugins: ['remove_button'],
            maxItems: null,
            load: this.loadTargets.bind(this),
            render: {
                option: this.renderItem.bind(this),
                item: this.renderItem.bind(this),
            },
            onChange: () => {
                // Convert array to comma-separated string for backend
                this.element.value = this.tomSelect.getValue().join(',')
            },
        }

        // Preload existing targets
        if (this.hasPreloadValue) {
            const preloaded = JSON.parse(this.preloadValue)
            settings.options = preloaded
            settings.items = preloaded.map((item) => item.id)
        }

        this.tomSelect = new TomSelect(this.element, settings)
    }

    disconnect() {
        if (this.tomSelect) {
            this.tomSelect.destroy()
        }
    }

    // Load targets from API via AJAX
    loadTargets(query, callback) {
        if (!query.length) return callback()
        fetch(`/target_search.json?q=${encodeURIComponent(query)}`)
            .then((res) => res.json())
            .then((json) => callback(json))
            .catch(() => callback())
    }

    // Dropdown item display
    // Shows: badges (Paused, Priority, Weight, Maxed Out) + target name
    renderItem(data, escape) {
        let html = '<div class="item d-flex align-items-center gap-1">'

        if (data.maxed_out) {
            html +=
                '<span class="badge text-bg-danger" title="Maxed Out"><i class="fa-solid fa-ban"></i></span>'
        }
        if (data.paused) {
            html +=
                '<span class="badge text-bg-light" title="Paused"><i class="fa-solid fa-pause"></i></span>'
        }
        if (data.priority || data.priority === 0) {
            html += `<span class="badge text-bg-danger" title="Priority">${escape(data.priority)}</span>`
        }
        if (data.weight || data.weight === 0) {
            html += `<span class="badge text-bg-dark" title="Weight">${escape(data.weight)}</span>`
        }
        html += `<span class="text-wrap text-muted" title="Target Name">${escape(data.name)}</span>`

        html += '</div>'
        return html
    }
}
